import { Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Banner.css";
import { useHistory } from "react-router-dom";

function Banner() {
  const history = useHistory();
  return (
    <div className="banner">
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={6}>
          <div>
            <Typography className="banner_text1">
              Welcome to Paokue programer Course
            </Typography>
            <Typography className="banner_text2">
              Unlock your programing knownledge and get more and more.
            </Typography>
            <Button
              className="banner_button"
              onClick={() => history.push("/register")}
            >
              Join Now
            </Button>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <div className="banner_image">
            <img src="/images/marketing.gif" alt="programmer" />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Banner;
